import React, { useEffect, useState } from 'react';
import Header from '../Component/Header'
import { Link } from 'react-router-dom'
import Footer from'../Component/Footer' 
import {getPrincipalMessage} from'../Service/Api'
import LazyLoad from 'react-lazyload';
const PrincipalMessage = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true); 
    console.log(data);
 
    useEffect(() => {
        const fetchData = async () => {
            try {
                const principalData = await getPrincipalMessage();
                setData(principalData);
                
            } catch (error) {
                console.log("Data Error", error);
            } finally{
                setLoading(false)
            }
        };
        fetchData();
    }, []);
    const emptyData = [
       { id: 1}
   ];
  return (
 
     <>
       <Header/>
        <div className="innerslide">
        <ul className="breadcrumb">
            <li><Link to="/"> Home</Link> </li> 
            <li> Principal's Message </li>
        </ul>
    </div>
    <div className="innersec">
      <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <h1>Principal's Message </h1>
                </div>
            </div>
            {data.length > 0 ? data.map((item) => (
                <div className="clearfix">
                 <LazyLoad><img src={`https://webapi.entab.info/api/image/${item.attachments}`} className="img-fluid col-md-4 float-md-end mb-3 msgimg" alt=""/></LazyLoad>
            
                   <p><div dangerouslySetInnerHTML={{ __html: item.message }} /></p> 
                  <p className="name"> {item.name}<span>  {item.category} </span></p>
          
             
            </div> 
            )) : emptyData.map((item) => (
                <div className="clearfix"> 
                <LazyLoad><img src="https://webapi.entab.info/api/image/SBSB/public/Images/slide1.JPG" className="img-fluid col-md-4 float-md-end mb-3 msgimg" alt=""/></LazyLoad>
                <p></p>
                 <p className="name">Principal Name<span>  Principal </span>
              
                </p> 
                </div> 
                ))}
        </div>
    </div>
       <Footer/>
     </>
  )
}

export default PrincipalMessage
